import axios from "axios.js";
import { showSnackbar } from "./UiAction";

// Defines all states values
export const GET_FEEDBACK_LIST = "GET_FEEDBACK_LIST";
export const CREATE_FEEDBACK_LIST = "CREATE_FEEDBACK_LIST";
export const CREATE_FEEDBACK_REPLY = "CREATE_FEEDBACK_REPLY";
export const CREATE_FEEDBACK_REPLY_GUEST = "CREATE_FEEDBACK_REPLY_GUEST";
export const GET_FEEDBACK_REPLIES_LIST = "GET_FEEDBACK_REPLIES_LIST";
export const GET_FEEDBACK_COUNTS = "GET_FEEDBACK_COUNTS";
export const APPLY_IS_READ_TRUE = "APPLY_IS_READ_TRUE";
export const RESET_FEEDBACK_REPLIES_DATA = "RESET_FEEDBACK_REPLIES_DATA";
export const GET_DISTRICT_FEEDBACK_LIST = "GET_DISTRICT_FEEDBACK_LIST";
export const GET_BLOCK_FEEDBACK_LIST = "GET_BLOCK_FEEDBACK_LIST";
export const GET_CLUSTER_FEEDBACK_LIST = "GET_CLUSTER_FEEDBACK_LIST";
export const GET_SCHOOL_FEEDBACK_LIST = "GET_SCHOOL_FEEDBACK_LIST";
export const CLOSE_COMPLAIN = "CLOSE_COMPLAIN";


export const getFeedbackList = (page, rowsPerPage) => (dispatch) => {
  axios.get(`feedback/list?page=${page}&size=${rowsPerPage}`).then((res) => {
    dispatch({
      type: GET_FEEDBACK_LIST,
      payload: res.data,
    });
  });
};

export const createFeedback = (data) => (dispatch) => {
  axios.post(`feedback/create`, data).then((res) => {
    dispatch(showSnackbar(res.data.message, 'top', "success"));
    dispatch({
      type: CREATE_FEEDBACK_LIST,
      payload: res.data,
    });
    setTimeout(() => dispatch(getFeedbackList(1,100)), 2000);
  })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const createFeedbackReply = (data) => (dispatch) => {
  axios.post(`feedback/reply/create`, data).then((res) => {
    dispatch({
      type: CREATE_FEEDBACK_REPLY,
      payload: res.data,
    });
    dispatch(getFeedbackRepliesList({ id: data.feedback_id }))
  })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getFeedbackRepliesList = (data) => (dispatch) => {
  axios.post(`feedback/replies/get`, data).then((res) => {
    dispatch({
      type: GET_FEEDBACK_REPLIES_LIST,
      payload: res.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getFeedbackCounts = () => (dispatch) => {
  axios.get(`feedback/count`).then((res) => {
    dispatch({
      type: GET_FEEDBACK_COUNTS,
      payload: res.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};
export const applyIsReadTrue = (id) => (dispatch) => {
  axios.get(`feedback/view/${id}`).then((res) => {
    dispatch({
      type: APPLY_IS_READ_TRUE,
      payload: res.data,
    });
  })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const createFeedbackReplyGuest = (data) => (dispatch) => {
  axios.post(`feedback/guest/create`, data).then((res) => {
    dispatch({
      type: CREATE_FEEDBACK_REPLY_GUEST,
      payload: res.data,
    });
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  })
    .catch((error) => {
      dispatch(showSnackbar(error.message, 'top', "error"));
    });
};

export const getFeedbackDistrictList = () => (dispatch) => { // get district list on global search api
  axios.get(`/feedback/district`).then((res) => {
    dispatch({
      type: GET_DISTRICT_FEEDBACK_LIST,
      payload: res.data,
    });
  });
};

export const getFeedbackBlockByDistrictList = (id) => (dispatch) => { // gt block list by district on global search api call
  axios.get(`feedback/block/${id}`).then((res) => {
    dispatch({
      type: GET_BLOCK_FEEDBACK_LIST,
      payload: res.data,
    });
  });
};

export const getFeedbackClusterbyblockList = (id) => (dispatch) => { // get cluster list by block on global search api call 
  axios.get(`feedback/cluster/${id}`).then((res) => {
    dispatch({
      type: GET_CLUSTER_FEEDBACK_LIST,
      payload: res.data,
    });
  });
};

export const getFeedbackSchoolByClusterList = (id) => (dispatch) => { // get cluster list by block on global search api call 
  axios.get(`feedback/school/${id}`).then((res) => {
    dispatch({
      type: GET_SCHOOL_FEEDBACK_LIST,
      payload: res.data,
    });
  });
};

export const closeComplain = (id) => (dispatch) => { // get cluster list by block on global search api call 
  axios.get(`feedback/close/${id}`).then((res) => {
    dispatch({
      type: CLOSE_COMPLAIN,
      payload: res.data,
    });
    dispatch(showSnackbar(res.data.message, 'top', "success"));
  });
};

export const resetFeedbackData = () => ({
  type: RESET_FEEDBACK_REPLIES_DATA,
});